import { gql } from '@apollo/client'

export const DELETE_TRAINING = gql`
  mutation DeleteTraining($input: ID!) {
    deleteTraining(trainingId: $input) {
      deleted
    }
  }
`
